import React from 'react'

const FullPageLoaderModal = () => {
    return (
        <div className="fp-container">
            <span className="spinner-border spinner-border-sl fp-loader" role="status">
            </span>  
        </div>
    ) 
}

export default FullPageLoaderModal